module.exports = __webpack_public_path__ + "static/media/ProfessionalUX.f6f75393.svg";